import { images } from 'assets'
import { useField } from 'formik'
import styles from './inputs.module.scss'

const CustomPlusMinusInput = (props) => {
  const [field, meta, helpers] = useField(props)
  const customClass = props.className === undefined ? '' : props.className + ' '

  const handleIncrement = () => {
    const currentValue = parseInt(field.value) || 0
    const newValue = currentValue + 1
    helpers.setValue(newValue)
  }

  const handleDecrement = () => {
    const currentValue = parseInt(field.value) || 0
    if (currentValue) {
      const newValue = currentValue - 1
      helpers.setValue(newValue)
    }
  }

  return (
    <div>
      <div
        className={
          meta.touched && meta.error
            ? styles.inputError + ' ' + styles.plusMinusRoot
            : styles.plusMinusRoot
        }
      >
        <button type="button" onClick={handleDecrement} className={styles.sm}>
          <img src={images.subtract} />
        </button>
        <input
          {...field}
          {...props}
          className={styles.emptyInput}
          type="text"
        />
        <button type="button" onClick={handleIncrement} className={styles.sm}>
          <img src={images.add} />
        </button>
      </div>
      {meta.touched && meta.error && (
        <div className={styles.error}>{meta.error}</div>
      )}
    </div>
  )
}

export default CustomPlusMinusInput
